/*OTHERS*/
import React from "react";

/*MATERIAL UI*/
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from "@mui/material";
import DialogActions from '@mui/material/DialogActions';

import { useTranslation } from "react-i18next";

export default function Filter(props: FilterPropsTypes) {
  const { t } = useTranslation();

  const keyPress = (event: any) => {
    if (event.keyCode == 13) {
      props.handleClickFilter();
    }
  }

  return (
    <>
      <div>
        <Dialog
          open={props.openFilter}
          onClose={() => props.setOpenFilter(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filter"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.deliveriesCif.text.filterCifCargo")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              <Grid>
                <Grid item>
                  <TextField
                    id={"pedidoId"}
                    name={"pedidoId"}
                    label={t("common.orderNumber")}
                    placeholder={t("common.orderNumber")}
                    variant="outlined"
                    sx={{ minWidth: "22vw" }}
                    value={props.filterPedido}
                    onChange={(event) => props.setFilterPedido(event.target.value)}
                    onKeyDown={keyPress}
                  />
                </Grid>
                <br />
                <Grid item>
                  <TextField
                    id={"itemId"}
                    name={"itemId"}
                    label={t("common.itemNumber")}
                    placeholder={t("common.itemNumber")}
                    variant="outlined"
                    sx={{ minWidth: "22vw" }}
                    value={props.filterItem}
                    onChange={(event) => props.setFilterItem(event.target.value)}
                    onKeyDown={keyPress}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={props.handleClickFilter}
              autoFocus
            >
              {t("common.filter")}
            </Button>
            <Button
              variant="outlined"
              color="success"
              onClick={() => props.setOpenFilter(false)}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

interface FilterPropsTypes {
  getApiResult: any;
  openFilter: boolean;
  setOpenFilter: any;
  filterPedido: string;
  setFilterPedido: any;
  filterItem: string;
  setFilterItem: any;
  handleClickFilter: any;
}